import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ step, stepCount }) => {
    const progressRatio = step / stepCount;

    return (
        <div className="progress-bar">
            <div className="progress-bar__filled" style={{ width: `${progressRatio * 100}%` }} />
        </div>
    );
};

ProgressBar.displayName = 'ProgressBar';

ProgressBar.propTypes = {
    step: PropTypes.number.isRequired,
    stepCount: PropTypes.number.isRequired,
};

/**
 * ProgressBar Functional Component.
 */
export default ProgressBar;
